var _style, _path, _path2, _line, _line2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTableTennis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1024 1024",
    style: {
      enableBackground: "new 0 0 1024 1024"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke-width:25;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M388.2,694.5c0,0,47.7-37.8,153.7,7.2c0,0,124.8,41.5,261.1-94.8s141-310.3,18.9-432.3s-296-117.4-432.3,18.9 s-94.8,261.1-94.8,261.1c45,106,7.2,153.7,7.2,153.7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135.4,861.1L135.4,861.1c-28.8-28.8-27.7-75.8,2.4-103.2l264.8-241.2l77.2,77.2L238.6,858.7 C211.2,888.8,164.2,889.9,135.4,861.1z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 315.2,
    y1: 429.2,
    x2: 567.3,
    y2: 681.3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 289.5,
    y1: 403.6,
    x2: 592.9,
    y2: 707
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 498.4,
    cy: 865.3,
    r: 71.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableTennis);
export default __webpack_public_path__ + "static/media/TableTennis.8c44afe5.svg";
export { ForwardRef as ReactComponent };